module.exports = __webpack_public_path__ + "img/biaoqian_yiyuan.ffc467ce.png";